import React from "react"

import { PrimitiveButton } from "@/primitives/PrimitiveButton"
import { ButtonProps } from "@/components/Button/protocols"

import useStyles from "@/components/Button/styles"

export const Secondary = ({
	children,
	...props
}: ButtonProps) => {
	const classes = useStyles()

	return (
		<PrimitiveButton
			{...props}
			sx={{
				...classes.button,
				...classes.secondary
			}}
			variant="outlined"
		>
			{children}
		</PrimitiveButton>
	)
}